import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { handleValidationErrors } from '../helpers/error-helpers';
import { AuthService } from './auth.service';
import { LogErrorService } from './log-error.service';
import { MessagingService } from './messaging.service';
import { ToastMessageService } from './toast-message.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private auth: AuthService, private router: Router, private logError: LogErrorService, private toast:ToastMessageService) { }

    messages = inject(MessagingService);

    handleError(error: unknown): void {
        // Always log to console for diagnostics
        console.error('Unhandled error:', error);

        // Show a user-friendly toast if possible
        try {
            if (error && (error as any).code == -100)
                return;

            let status = (error as any)?.status;

            if (!status && (error as any).cause) {
                status = (error as any).cause.status;
            }
            if (status == 403) {
                window.location.href = '/auth/unauthorized-access';
                return;
            }
            if (status === 401) {
                window.location.href = '/auth/logout';
                return;
            }

            if (status === 400 || status == 429) {
                setTimeout(() => {
                    handleValidationErrors(error, this.messages.validationErrors, this.toast);
                });
                return;
            }
            const message = (error && (error as any).message) ? (error as any).message : 'An unexpected error occurred';
            if (message.indexOf("ResizeObserver") != -1)
                return;

            //ng-boostrap datepicer is throwing an exception when calendar is shown and then ESC is pressed
            if (message.indexOf("Cannot read properties of undefined (reading 'parentNode')") != -1
                && (error as any).stack && (error as any).stack.indexOf('Dropdown.getOrCreateInstance') != -1
            )
                return;



            setTimeout(() => {
                this.logError.logError({
                    time: new Date(),
                    route: this.router.url,
                    message: message,
                    user: this.auth.getUsername() || 'Anonymous',
                    error: error
                });
            });
            //this.toastService.subject.next({ message, title: 'Error Inesperado' });


        } catch (e) {
            // If toast or router throws, just ensure we don't crash the handler
            console.error('GlobalErrorHandler failed to handle error', e);
        }
    }
}
